import axios from 'axios';

const apiAuthAxios = axios.create({
  baseURL: `${process.env.REACT_APP_API_SERVER}`,
  withCredentials: true,
});

export const getSession = async () => {
  return await apiAuthAxios.get('/auth/getSession');
};